/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Entity } from "@backstage/catalog-model";
import { identityApiRef, useApi } from "@backstage/core-plugin-api";
import { DefaultEntityFilters, EntityFilter, EntityKindPicker, EntityNamespacePicker, EntityOwnerPicker, EntityTypePicker, useEntityList, UserListPicker } from "@backstage/plugin-catalog-react";

type GroupsFilters = DefaultEntityFilters & {
  groupOwnership?: GroupOwnershipEntityFilter;
};

class GroupOwnershipEntityFilter implements EntityFilter {
  constructor(private readonly allowedGroups: string[]) {}

  filterEntity(entity: Entity): boolean {
    const owner = entity.spec?.owner?.toString().toLowerCase() ?? '';

    return this.allowedGroups.some(group =>
      owner.includes(group.split('/').pop()?.toLowerCase() ?? '')
    );
  }
}

export const GroupsPicker = () => {
  const [userOwnershipEntities, setUserOwnershipEntities] = useState<string[]>([]);
  const identityApi = useApi(identityApiRef);
  const { updateFilters } = useEntityList<GroupsFilters>();

  useEffect(() => {
      identityApi.getBackstageIdentity().then(identity => {
        const ownershipEntities = identity.ownershipEntityRefs ?? [];

        setUserOwnershipEntities(ownershipEntities);
      });
    }, [identityApi]);

  useEffect(() => {
    updateFilters({
      groupOwnership: new GroupOwnershipEntityFilter(userOwnershipEntities),
    });
  }, [updateFilters, userOwnershipEntities]);

  return (
    <>
      <EntityKindPicker />
      <EntityTypePicker />
      <UserListPicker
        availableFilters={['owned', 'starred']}
        initialFilter='all'
      />
      <EntityOwnerPicker />
      <EntityNamespacePicker />
    </>
  );
};